import { FETCH_PIN_URI, SEARCH_URI_ALLORGMETRICS } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";
import { getServiceName, getXClientIdHeader, ServiceName } from "src/utils/getservicename";

type GetPinsParams = {
  pageNo: number;
  fresh?: boolean;
  timeTab: string;
  tabIndex?: number;
};

function getPageSize() {
  if (getServiceName() === ServiceName.ANOBIS_IMCOM) {
    return "10";
  }
  if (getServiceName() === ServiceName.ANOBIS_INDIA_2) {
    return "10";
  }
  return "5";
}

export const getPins = ({ pageNo, fresh, timeTab, tabIndex }: GetPinsParams): ApiResponse => {
  const params = {
    pageNo: pageNo + "",
    isNotesEnabled: "true",
    pageSize: getPageSize(),
    timeTab,
    ...(tabIndex !== undefined && tabIndex !== null && { tabIndex: tabIndex + "" }),
  };
  let headers = fresh
    ? { "X-Clear-Cache": "true", ...getXClientIdHeader() }
    : {
        "X-Clear-Cache": "false",
        ...getXClientIdHeader(),
      };
  return appFetch.get(FETCH_PIN_URI, {
    params,
    headers,
  });
};

export const searchPins = (text: string): ApiResponse =>
  appFetch.get(`${SEARCH_URI_ALLORGMETRICS}/${encodeURIComponent(text)}`, {
    headers: getXClientIdHeader(),
  });
